/**
 * Official World Masters Athletics (WMA) 2020 Road Standards
 * Distances: 5000m (5K), 10000m (10K), 21097.5m (Half Marathon), 42195m (Marathon)
 * Genders: Male (M), Female (F)
 * Ages: 5 - 100
 */

export interface WMAStandardEntry {
  open: number;
  ages: Record<string, number>;
}

export type WMAStandardsMap = Record<"M" | "F", Record<"5000" | "10000" | "21097" | "42195", WMAStandardEntry>>;

export const WMA_DATA = {
  "M": {
    "5000": {
      "open": 779,
      "ages": {
        "5": 1286,
        "6": 1181,
        "7": 1098,
        "8": 1031,
        "9": 977,
        "10": 932,
        "11": 895,
        "12": 866,
        "13": 842,
        "14": 822,
        "15": 807,
        "16": 795,
        "17": 786,
        "18": 780,
        "19": 779,
        "20": 779,
        "21": 779,
        "22": 779,
        "23": 779,
        "24": 779,
        "25": 779,
        "26": 779,
        "27": 779,
        "28": 779,
        "29": 780,
        "30": 781,
        "31": 783,
        "32": 785,
        "33": 788,
        "34": 792,
        "35": 796,
        "36": 800,
        "37": 805,
        "38": 811,
        "39": 817,
        "40": 823,
        "41": 828,
        "42": 834,
        "43": 840,
        "44": 846,
        "45": 853,
        "46": 859,
        "47": 865,
        "48": 872,
        "49": 878,
        "50": 885,
        "51": 892,
        "52": 899,
        "53": 906,
        "54": 913,
        "55": 920,
        "56": 927,
        "57": 935,
        "58": 943,
        "59": 950,
        "60": 958,
        "61": 966,
        "62": 974,
        "63": 982,
        "64": 991,
        "65": 999,
        "66": 1008,
        "67": 1017,
        "68": 1026,
        "69": 1037,
        "70": 1048,
        "71": 1061,
        "72": 1075,
        "73": 1090,
        "74": 1107,
        "75": 1125,
        "76": 1145,
        "77": 1166,
        "78": 1190,
        "79": 1216,
        "80": 1244,
        "81": 1275,
        "82": 1308,
        "83": 1345,
        "84": 1386,
        "85": 1431,
        "86": 1480,
        "87": 1535,
        "88": 1597,
        "89": 1665,
        "90": 1743,
        "91": 1830,
        "92": 1930,
        "93": 2044,
        "94": 2177,
        "95": 2332,
        "96": 2517,
        "97": 2739,
        "98": 3012,
        "99": 3353,
        "100": 3794
      }
    },
    "10000": {
      "open": 1603,
      "ages": {
        "5": 2647,
        "6": 2430,
        "7": 2259,
        "8": 2121,
        "9": 2010,
        "10": 1918,
        "11": 1843,
        "12": 1782,
        "13": 1732,
        "14": 1692,
        "15": 1660,
        "16": 1636,
        "17": 1617,
        "18": 1604,
        "19": 1603,
        "20": 1603,
        "21": 1603,
        "22": 1603,
        "23": 1603,
        "24": 1603,
        "25": 1603,
        "26": 1603,
        "27": 1603,
        "28": 1603,
        "29": 1603,
        "30": 1603,
        "31": 1604,
        "32": 1606,
        "33": 1608,
        "34": 1613,
        "35": 1618,
        "36": 1624,
        "37": 1632,
        "38": 1641,
        "39": 1651,
        "40": 1663,
        "41": 1676,
        "42": 1689,
        "43": 1702,
        "44": 1716,
        "45": 1730,
        "46": 1744,
        "47": 1758,
        "48": 1773,
        "49": 1787,
        "50": 1803,
        "51": 1818,
        "52": 1833,
        "53": 1849,
        "54": 1865,
        "55": 1882,
        "56": 1898,
        "57": 1915,
        "58": 1932,
        "59": 1950,
        "60": 1968,
        "61": 1986,
        "62": 2005,
        "63": 2024,
        "64": 2043,
        "65": 2063,
        "66": 2083,
        "67": 2103,
        "68": 2124,
        "69": 2146,
        "70": 2169,
        "71": 2194,
        "72": 2223,
        "73": 2254,
        "74": 2288,
        "75": 2326,
        "76": 2367,
        "77": 2412,
        "78": 2461,
        "79": 2515,
        "80": 2574,
        "81": 2639,
        "82": 2710,
        "83": 2788,
        "84": 2874,
        "85": 2970,
        "86": 3075,
        "87": 3193,
        "88": 3325,
        "89": 3473,
        "90": 3640,
        "91": 3830,
        "92": 4048,
        "93": 4300,
        "94": 4594,
        "95": 4941,
        "96": 5356,
        "97": 5863,
        "98": 6490,
        "99": 7293,
        "100": 8349
      }
    },
    "21097": {
      "open": 3503,
      "ages": {
        "5": 5784,
        "6": 5311,
        "7": 4937,
        "8": 4636,
        "9": 4392,
        "10": 4192,
        "11": 4028,
        "12": 3894,
        "13": 3785,
        "14": 3697,
        "15": 3628,
        "16": 3576,
        "17": 3533,
        "18": 3505,
        "19": 3503,
        "20": 3503,
        "21": 3503,
        "22": 3503,
        "23": 3503,
        "24": 3503,
        "25": 3503,
        "26": 3503,
        "27": 3503,
        "28": 3503,
        "29": 3503,
        "30": 3503,
        "31": 3503,
        "32": 3504,
        "33": 3507,
        "34": 3512,
        "35": 3521,
        "36": 3531,
        "37": 3545,
        "38": 3561,
        "39": 3580,
        "40": 3602,
        "41": 3627,
        "42": 3655,
        "43": 3685,
        "44": 3716,
        "45": 3747,
        "46": 3778,
        "47": 3810,
        "48": 3842,
        "49": 3875,
        "50": 3909,
        "51": 3943,
        "52": 3978,
        "53": 4014,
        "54": 4050,
        "55": 4087,
        "56": 4124,
        "57": 4162,
        "58": 4201,
        "59": 4240,
        "60": 4281,
        "61": 4321,
        "62": 4363,
        "63": 4406,
        "64": 4450,
        "65": 4494,
        "66": 4539,
        "67": 4586,
        "68": 4633,
        "69": 4681,
        "70": 4731,
        "71": 4783,
        "72": 4841,
        "73": 4906,
        "74": 4977,
        "75": 5056,
        "76": 5142,
        "77": 5237,
        "78": 5341,
        "79": 5455,
        "80": 5581,
        "81": 5718,
        "82": 5870,
        "83": 6038,
        "84": 6222,
        "85": 6426,
        "86": 6653,
        "87": 6908,
        "88": 7192,
        "89": 7511,
        "90": 7874,
        "91": 8285,
        "92": 8758,
        "93": 9307,
        "94": 9946,
        "95": 10703,
        "96": 11611,
        "97": 12724,
        "98": 14108,
        "99": 15879,
        "100": 18235
      }
    },
    "42195": {
      "open": 7377,
      "ages": {
        "5": 12181,
        "6": 11184,
        "7": 10396,
        "8": 9763,
        "9": 9249,
        "10": 8828,
        "11": 8483,
        "12": 8200,
        "13": 7970,
        "14": 7785,
        "15": 7640,
        "16": 7531,
        "17": 7439,
        "18": 7382,
        "19": 7377,
        "20": 7377,
        "21": 7377,
        "22": 7377,
        "23": 7377,
        "24": 7377,
        "25": 7377,
        "26": 7377,
        "27": 7377,
        "28": 7377,
        "29": 7377,
        "30": 7377,
        "31": 7377,
        "32": 7378,
        "33": 7385,
        "34": 7397,
        "35": 7414,
        "36": 7436,
        "37": 7465,
        "38": 7499,
        "39": 7540,
        "40": 7586,
        "41": 7638,
        "42": 7697,
        "43": 7760,
        "44": 7825,
        "45": 7890,
        "46": 7955,
        "47": 8023,
        "48": 8091,
        "49": 8161,
        "50": 8232,
        "51": 8304,
        "52": 8377,
        "53": 8452,
        "54": 8528,
        "55": 8606,
        "56": 8684,
        "57": 8764,
        "58": 8846,
        "59": 8930,
        "60": 9015,
        "61": 9101,
        "62": 9189,
        "63": 9279,
        "64": 9371,
        "65": 9465,
        "66": 9559,
        "67": 9657,
        "68": 9757,
        "69": 9858,
        "70": 9962,
        "71": 10072,
        "72": 10195,
        "73": 10332,
        "74": 10482,
        "75": 10647,
        "76": 10828,
        "77": 11029,
        "78": 11247,
        "79": 11487,
        "80": 11752,
        "81": 12042,
        "82": 12361,
        "83": 12715,
        "84": 13103,
        "85": 13533,
        "86": 14011,
        "87": 14547,
        "88": 15145,
        "89": 15817,
        "90": 16581,
        "91": 17448,
        "92": 18443,
        "93": 19599,
        "94": 20945,
        "95": 22539,
        "96": 24451,
        "97": 26796,
        "98": 29710,
        "99": 33441,
        "100": 38402
      }
    }
  },
  "F": {
    "5000": {
      "open": 886,
      "ages": {
        "5": 1264,
        "6": 1207,
        "7": 1157,
        "8": 1114,
        "9": 1076,
        "10": 1043,
        "11": 1014,
        "12": 989,
        "13": 967,
        "14": 947,
        "15": 931,
        "16": 915,
        "17": 900,
        "18": 890,
        "19": 886,
        "20": 886,
        "21": 886,
        "22": 886,
        "23": 886,
        "24": 886,
        "25": 886,
        "26": 886,
        "27": 886,
        "28": 886,
        "29": 886,
        "30": 886,
        "31": 886,
        "32": 887,
        "33": 888,
        "34": 890,
        "35": 892,
        "36": 894,
        "37": 898,
        "38": 901,
        "39": 905,
        "40": 910,
        "41": 915,
        "42": 921,
        "43": 928,
        "44": 935,
        "45": 943,
        "46": 951,
        "47": 960,
        "48": 970,
        "49": 981,
        "50": 991,
        "51": 1002,
        "52": 1013,
        "53": 1025,
        "54": 1036,
        "55": 1048,
        "56": 1061,
        "57": 1073,
        "58": 1086,
        "59": 1099,
        "60": 1112,
        "61": 1126,
        "62": 1140,
        "63": 1155,
        "64": 1169,
        "65": 1184,
        "66": 1200,
        "67": 1216,
        "68": 1232,
        "69": 1249,
        "70": 1267,
        "71": 1284,
        "72": 1303,
        "73": 1322,
        "74": 1341,
        "75": 1361,
        "76": 1382,
        "77": 1403,
        "78": 1425,
        "79": 1448,
        "80": 1473,
        "81": 1502,
        "82": 1535,
        "83": 1572,
        "84": 1613,
        "85": 1659,
        "86": 1711,
        "87": 1771,
        "88": 1837,
        "89": 1913,
        "90": 2000,
        "91": 2099,
        "92": 2214,
        "93": 2348,
        "94": 2506,
        "95": 2695,
        "96": 2923,
        "97": 3205,
        "98": 3560,
        "99": 4020,
        "100": 4641
      }
    },
    "10000": {
      "open": 1820,
      "ages": {
        "5": 2596,
        "6": 2506,
        "7": 2402,
        "8": 2311,
        "9": 2233,
        "10": 2163,
        "11": 2103,
        "12": 2050,
        "13": 2004,
        "14": 1963,
        "15": 1928,
        "16": 1896,
        "17": 1865,
        "18": 1840,
        "19": 1825,
        "20": 1820,
        "21": 1820,
        "22": 1820,
        "23": 1820,
        "24": 1820,
        "25": 1820,
        "26": 1820,
        "27": 1820,
        "28": 1820,
        "29": 1820,
        "30": 1820,
        "31": 1820,
        "32": 1822,
        "33": 1825,
        "34": 1828,
        "35": 1833,
        "36": 1839,
        "37": 1846,
        "38": 1854,
        "39": 1863,
        "40": 1874,
        "41": 1886,
        "42": 1899,
        "43": 1913,
        "44": 1929,
        "45": 1947,
        "46": 1966,
        "47": 1986,
        "48": 2009,
        "49": 2032,
        "50": 2056,
        "51": 2081,
        "52": 2106,
        "53": 2132,
        "54": 2159,
        "55": 2186,
        "56": 2214,
        "57": 2243,
        "58": 2272,
        "59": 2302,
        "60": 2333,
        "61": 2365,
        "62": 2398,
        "63": 2432,
        "64": 2466,
        "65": 2502,
        "66": 2538,
        "67": 2576,
        "68": 2615,
        "69": 2655,
        "70": 2696,
        "71": 2739,
        "72": 2783,
        "73": 2828,
        "74": 2875,
        "75": 2924,
        "76": 2974,
        "77": 3026,
        "78": 3080,
        "79": 3137,
        "80": 3204,
        "81": 3278,
        "82": 3361,
        "83": 3455,
        "84": 3561,
        "85": 3680,
        "86": 3816,
        "87": 3969,
        "88": 4146,
        "89": 4347,
        "90": 4581,
        "91": 4852,
        "92": 5172,
        "93": 5552,
        "94": 6013,
        "95": 6578,
        "96": 7289,
        "97": 8202,
        "98": 9430,
        "99": 11145,
        "100": 13736
      }
    },
    "21097": {
      "open": 3912,
      "ages": {
        "5": 5581,
        "6": 6130,
        "7": 5759,
        "8": 5450,
        "9": 5190,
        "10": 4971,
        "11": 4784,
        "12": 4625,
        "13": 4490,
        "14": 4375,
        "15": 4278,
        "16": 4191,
        "17": 4107,
        "18": 4035,
        "19": 3980,
        "20": 3942,
        "21": 3919,
        "22": 3912,
        "23": 3912,
        "24": 3912,
        "25": 3912,
        "26": 3912,
        "27": 3912,
        "28": 3912,
        "29": 3912,
        "30": 3913,
        "31": 3916,
        "32": 3922,
        "33": 3929,
        "34": 3939,
        "35": 3951,
        "36": 3966,
        "37": 3982,
        "38": 4002,
        "39": 4023,
        "40": 4047,
        "41": 4074,
        "42": 4104,
        "43": 4136,
        "44": 4171,
        "45": 4210,
        "46": 4252,
        "47": 4297,
        "48": 4345,
        "49": 4396,
        "50": 4449,
        "51": 4503,
        "52": 4558,
        "53": 4614,
        "54": 4672,
        "55": 4731,
        "56": 4792,
        "57": 4855,
        "58": 4919,
        "59": 4985,
        "60": 5052,
        "61": 5122,
        "62": 5193,
        "63": 5267,
        "64": 5342,
        "65": 5420,
        "66": 5500,
        "67": 5582,
        "68": 5667,
        "69": 5755,
        "70": 5845,
        "71": 5938,
        "72": 6034,
        "73": 6134,
        "74": 6236,
        "75": 6342,
        "76": 6457,
        "77": 6584,
        "78": 6724,
        "79": 6879,
        "80": 7051,
        "81": 7243,
        "82": 7457,
        "83": 7695,
        "84": 7959,
        "85": 8257,
        "86": 8592,
        "87": 8972,
        "88": 9404,
        "89": 9896,
        "90": 10465,
        "91": 11129,
        "92": 11912,
        "93": 12843,
        "94": 13966,
        "95": 15353,
        "96": 17105,
        "97": 19386,
        "98": 22457,
        "99": 26813,
        "100": 33493
      }
    },
    "42195": {
      "open": 8125,
      "ages": {
        "5": 11591,
        "6": 11187,
        "7": 10722,
        "8": 10319,
        "9": 9967,
        "10": 9658,
        "11": 9389,
        "12": 9152,
        "13": 8944,
        "14": 8764,
        "15": 8607,
        "16": 8464,
        "17": 8325,
        "18": 8213,
        "19": 8147,
        "20": 8125,
        "21": 8125,
        "22": 8125,
        "23": 8125,
        "24": 8125,
        "25": 8125,
        "26": 8125,
        "27": 8125,
        "28": 8125,
        "29": 8125,
        "30": 8125,
        "31": 8127,
        "32": 8134,
        "33": 8146,
        "34": 8163,
        "35": 8186,
        "36": 8213,
        "37": 8245,
        "38": 8284,
        "39": 8327,
        "40": 8377,
        "41": 8433,
        "42": 8495,
        "43": 8563,
        "44": 8638,
        "45": 8720,
        "46": 8809,
        "47": 8907,
        "48": 9012,
        "49": 9123,
        "50": 9237,
        "51": 9354,
        "52": 9474,
        "53": 9597,
        "54": 9724,
        "55": 9853,
        "56": 9986,
        "57": 10123,
        "58": 10264,
        "59": 10409,
        "60": 10557,
        "61": 10711,
        "62": 10868,
        "63": 11030,
        "64": 11198,
        "65": 11370,
        "66": 11548,
        "67": 11731,
        "68": 11920,
        "69": 12116,
        "70": 12318,
        "71": 12527,
        "72": 12743,
        "73": 12967,
        "74": 13199,
        "75": 13448,
        "76": 13725,
        "77": 14033,
        "78": 14375,
        "79": 14757,
        "80": 15181,
        "81": 15655,
        "82": 16185,
        "83": 16780,
        "84": 17451,
        "85": 18209,
        "86": 19073,
        "87": 20062,
        "88": 21203,
        "89": 22532,
        "90": 24095,
        "91": 25958,
        "92": 28212,
        "93": 30988,
        "94": 34486,
        "95": 39025,
        "96": 45139,
        "97": 53808,
        "98": 67038,
        "99": 89680,
        "100": 137247
      }
    }
  }
} as const;
